/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Manager_Remove_Group_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Delete {name}?" |
*
* @param {Team_Manager_Remove_Group_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_group_confirm_title = /** @type {((inputs: Team_Manager_Remove_Group_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Group_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer ${i?.name} ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eliminare ${i?.name}?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалить ${i?.name}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Eliminar ${i?.name}?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除 ${i?.name}？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} を削除しますか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} हटाएँ?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eliminar ${i?.name}?`)
	return /** @type {LocalizedString} */ (`Delete ${i?.name}?`)
});